export function hamburger () {
  const hamburger = document.querySelector('.js-hamburger');
  const hamburgerLogo = document.querySelector('.js-hamburgerLogo');
  const hamburgerNav = document.querySelector('.js-hamburgerNav');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('is-active');
    hamburgerLogo.classList.toggle('is-active');
    hamburgerNav.classList.toggle('is-active');
  })
}